import { createSelector } from 'reselect';

export const siteMaintenanceLogSelector = state => state.entities.siteMaintenanceLogs;

export function addUsersToSiteMaintenanceLogs(a, b) {
  return createSelector(a, b, (logs, users) =>
    logs.map(log => {
      if (log.get('entered_by', null) !== null) {
        log = log.set('entered_by', users.get(log.get('entered_by').toString(), new Map()));
      }
      if (log.get('resolved_by', null) !== null) {
        log = log.set('resolved_by', users.get(log.get('resolved_by').toString(), new Map()));
      }
      return log;
    }),
  );
}
